/* This function creates a fade-in effect if the view hits the bottom of an element */

function fadeInElements() {
	$('.fade-in').each(function (i) {
		const bottom_of_object = $(this).offset().top + $(this).outerHeight(),
			bottom_of_window = $(window).scrollTop() + $(window).height();

		if (bottom_of_window > bottom_of_object) {
			$(this).animate({
				'opacity': '1'
			}, 500);
		}
	});
};

$(window).on('load resize scroll', () => {
	fadeInElements();
});
